import { render, staticRenderFns } from "./DeviceItem.vue?vue&type=template&id=162301f4&scoped=true&"
import script from "./DeviceItem.vue?vue&type=script&lang=js&"
export * from "./DeviceItem.vue?vue&type=script&lang=js&"
import style0 from "./DeviceItem.vue?vue&type=style&index=0&id=162301f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162301f4",
  null
  
)

export default component.exports